<template>
  <div class="tab_user" @click="lookUser">
    <div v-if="city" class="city">
      {{
        user.city && user.city.length > 2 ? user.city.slice(0, 2) : user.city
      }}
    </div>
    <div class="flex">
      <div class="name ">
        <div class="username" :title="user.name">
          {{ showName(user.name) || "" }}
        </div>
        
        <img
          v-if="user.gender == '男' || user.sex == 1"
          src="../../assets/images/icon/Frame@2x.png"
          alt=""
        />
        <img
          v-else-if="user.gender == '女' || user.sex == 2"
          src="../../assets/images/icon/female@2x.png"
          alt=""
        />
        <img v-else src="@/assets/images/unknown.png" alt="" />
      </div>
      <!-- <div class="age">{{user.age}}</div> -->
      
      <!-- <div class="mobile">
        {{user.mobile||user.customerPhone||user.phone||''}}
      </div> -->
    </div>
    <div v-if="user.lock == 1" class="lock isLock">锁定</div>
    <publicPoll v-if="isPublicPool" :id="user.publicPool" />
  </div>
</template>
<script>
import { broadcast } from "@/utils/util";
import publicPoll from "@/components/common/publicPoll.vue";
export default {
  components: { publicPoll },
  name: "TabUser",
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    },
    city: {
      type: Boolean,
      default: true
    },
    isPublicPool: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      showDialog: false
    };
  },
  mounted() {},
  methods: {
    // 查看用户信息
    lookUser() {
      const row = this.user;
      const list = this.list;
      broadcast("look.user.follow", { data: row, list: list });
    },

    // 展示用户姓名
    showName(str) {
      let o = str;
      if (!str) {
        return "";
      }
      if (str.length > 3) {
        o = str.slice(0, 3) + "...";
      }
      return o;
    }
  }
};
</script>
<style lang="scss" scoped>
.tab_user {
  display: flex;
  align-items: center;
  cursor: pointer;
  .flex{
    display: flex;
    align-items: center;
    .age{
      padding-left: 4px;
    }
  }
  .city {
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    background: linear-gradient(136deg, #5393fe 0%, #41cad5 100%);
    border-radius: 4px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 26px;
    margin-right: 7px;
  }
  .name {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
    text-decoration: underline;
    text-decoration-color: #4593f9;
    .username {
      width: 54px;
    }
    
    img {
      width: 12px;
      height: 12px;
      margin-left: 4px;
    }
  }
  .mobile {
    font-size: 12px;
    font-family: DIN-Regular, DIN;
    font-weight: 400;
    color: #999999;
    margin: 0;
    padding: 0;
  }
  .lock {
    padding: 2px 4px;
    border-radius: 3px 3px 3px 3px;
    background: rgba(243, 85, 71, 0.09);
    color: rgba(255, 39, 20, 0.15);
    font-size: 12px;
    text-align: center;
    flex-shrink: 0;
    line-height: 1;
    margin-left: 4px;
  }
  .isLock {
    background: #f35547;
    color: #fff;
  }
}
.dialog_btn {
  .btn {
    width: 88px;
    height: 32px;
    border-radius: 4px;
    border: 0;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    cursor: pointer;
    margin-left: 16px;
  }
  .btn:hover {
    opacity: 0.8;
  }
  .btn_primary {
    background: #cce2ff;
    color: #167fff;
  }
  .btn_warning {
    background: #ffe3cc;
    color: #ff8f2e;
  }
  .btn_danger {
    background: #ffcccc;
    color: #ff5e59;
  }
}
</style>
